import Grid2 from '@mui/material/Grid2';
import Button from "@mui/material/Button";
import { CraftsFilter } from "./craftsFilter";
import { DownHoursFilter } from "./downHoursFilter";
import { SearchFilter } from "./SearchFilter";
import { TypeFilter } from "./typeFilter";
import { useInitialValues } from "./hooks/useInitialValues";
import { useSearchParamsToReducer } from "./hooks/useSearchParamsToReducer";
import { useSearchParams } from "react-router-dom";
import { useUserContext } from "@dexteel/mesf-core";
import { useTaskListContext } from "../context/taskListContext";

export const Filters = () => {
	useInitialValues();
	useSearchParamsToReducer();
	const [searchParams, setSearchParams] = useSearchParams();
	const {
		state: { defaultAreaId },
	} = useUserContext();
	const {
		actions: { setAssetSearchId },
	} = useTaskListContext();

	const resetFilter = () => {
		searchParams.delete("search");
		searchParams.delete("downHours");
		searchParams.delete("craft");
		searchParams.set("type", "A");
		setSearchParams(searchParams, { replace: true });
		setAssetSearchId(defaultAreaId);
	};

	return (
		<>
			<Grid2 size={{ lg: 4, md: 12, xs: 12 }}>
				<SearchFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 12, xs: 12 }}>
				<CraftsFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 12, xs: 12 }}>
				<TypeFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 12, xs: 12 }}>
				<DownHoursFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 12, xs: 12 }}>
				<Button
					fullWidth
					variant="contained"
					color="inherit"
					onClick={resetFilter}>
					RESET
				</Button>
			</Grid2>
		</>
	);
};
